<template>
    <div>
        <h1>Alkine</h1>
        <p>
            Alkine sind ungesättigte, acyclische Kohlenwasserstoffe. Das heißt,
            sie bestehen ausschließlich aus C und H Atomen mit mindestens einer
            Dreifachbindung und besitzen keine Kohlenstoffringe. Für alle gilt
            eine allgemeine Strukturformel von C<sub>n</sub>H<sub>2n-2</sub>.
            Die Dreifachbindung ist nicht frei drehbar und bestehen aus einer
            Sigma und zwei Pi Bindungen, d.h. einer Überlappung von plenaren
            sp1-Hybrid-Orbitalen. Verbindungen mit zwei oder mehreren
            Dreifachbindungen werden Polyine genannt.
        </p>
        <img
            src="@/assets/img/stoffe/alkine/allgemeine-struktur.png"
            alt="Allgemeine Struktur der Alkine"
            title="Allgemeine Struktur der Alkine"
            width="128px"
            height="auto"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Homologe Reihe"></chapter-heading>
        <div class="row">
            <table class="column left">
                <tr>
                    <th>1.</th>
                    <td>C<sub>2</sub>H<sub>2</sub></td>
                    <td>Ethin</td>
                </tr>
                <tr>
                    <th>2.</th>
                    <td>C<sub>3</sub>H<sub>4</sub></td>
                    <td>Propin</td>
                </tr>
                <tr>
                    <th>3.</th>
                    <td>C<sub>4</sub>H<sub>6</sub></td>
                    <td>Butin</td>
                </tr>
                <tr>
                    <th>4.</th>
                    <td>C<sub>5</sub>H<sub>8</sub></td>
                    <td>Pentin</td>
                </tr>
                <tr>
                    <th>5.</th>
                    <td>C<sub>6</sub>H<sub>10</sub></td>
                    <td>Hexin</td>
                </tr>
                <tr>
                    <th>6.</th>
                    <td>C<sub>7</sub>H<sub>12</sub></td>
                    <td>Heptin</td>
                </tr>
                <tr>
                    <th>7.</th>
                    <td>C<sub>8</sub>H<sub>14</sub></td>
                    <td>Octin</td>
                </tr>
                <tr>
                    <th>8.</th>
                    <td>C<sub>9</sub>H<sub>16</sub></td>
                    <td>Nonin</td>
                </tr>
                <tr>
                    <th>9.</th>
                    <td>C<sub>10</sub>H<sub>18</sub></td>
                    <td>Decin</td>
                </tr>
                <tr>
                    <td>...</td>
                </tr>
            </table>

            <table class="column left">
                <tr>
                    <th>Allgemein:</th>
                    <td>C<sub>n</sub>H<sub>2n-2</sub></td>
                </tr>
                <tr>
                    <th>Hinweis:</th>
                    <td>
                        Es gibt kein <em>Methin</em>, da bei einem einzelnen
                        C-Atom keine Dreifachbindung vorliegen kann.
                    </td>
                </tr>
            </table>
        </div>
        <hr class="chapter-split" />
        <chapter-heading title="Reaktionen"></chapter-heading>
        <ul>
            <li>
                Halogenierung (<router-link
                    to="/reaktionen/elektrophile-addition"
                    >Elektrophile Addition</router-link
                >) =>
                <router-link to="halogenalkene">Halogenalkene</router-link> =>
                <router-link to="halogenalkane">Halogenalkane</router-link>
            </li>
            <li>
                Hydrierung => <router-link to="alkene">Alkene</router-link> =>
                <router-link to="alkane">Alkane</router-link>
            </li>
            <li>
                Hydrohalogenierung (<router-link
                    to="/reaktionen/elektrophile-addition"
                    >Elektrophile Addition</router-link
                >) =>
                <router-link to="halogenalkane">Halogenalkane</router-link>
            </li>
        </ul>
        <hr class="chapter-split" />
        <chapter-heading
            title="Beispiel einer Strukturformel"
        ></chapter-heading>
        <img
            src="@/assets/img/stoffe/alkine/pentin.png"
            alt="Beispielhafte Strukturformel: Pentin"
            title="Beispielhafte Strukturformel: Pentin"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Zusammenfassung"></chapter-heading>
        <table>
            <tr>
                <th>Beschreibung</th>
                <td>
                    <ul>
                        <li>bestehen nur aus C-Atomen und H-Atomen</li>
                        <li>besitzen mindestens eine Dreifachbindung</li>
                        <li>ungestättigte, acyclische Kohlenwasserstoffe</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th>Allgemeine Summenformel</th>
                <td>C<sub>n</sub>H<sub>2n-2</sub></td>
            </tr>
            <tr>
                <th>Eigenschaften</th>
                <td>
                    <ul>
                        <li>ungesättigt</li>
                        <li>hydrophob</li>
                        <li>lipophil</li>
                        <li>brennbar</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th>Bindungen</th>
                <td>
                    Einfachbindungen (Sigma-Bindungen) und Dreifachbindungen (1
                    Sigma- & 2 Pi-Bindungen)
                </td>
            </tr>
        </table>
    </div>
</template>
<script>
import ChapterHeading from '../../components/chapterHeading';
export default {
    components: { ChapterHeading },
};
</script>
